import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAdminAxiosInstance } from "../../../../api/Admin";

const initialState = {
  currentPage: 1,
  currentPageSize: 10,
  currentFilter: "all",
  sortBy: "",
  sortOrder: "desc",
  search: "",
  editContactData: {},
  showDeleteModal: false,
  showEditModal: false,
  selectedId: "",
  isEdit: false,
};
export const getContactEditData = createAsyncThunk(
  "contact/edit",
  async (id, { rejectWithValue }) => {
    const api = await getAdminAxiosInstance();
    try {
      const response = await api.get(`/contact/edit?contact_id=${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const contactSlice = createSlice({
  name: "contact",
  initialState,
  reducers: {
    updateConfig: (state, action) => {
      action.payload(state);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getContactEditData.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getContactEditData.fulfilled, (state, action) => {
        state.editContactData = action.payload?.data;
      })
      .addCase(getContactEditData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload?.data;
      });
  },
});

export const { updateConfig } = contactSlice.actions;
export default contactSlice.reducer;
